import { handleApiError, handleApiResponse } from "../utils/utils";
import { ApiClient } from "./apiConfig";

export const getSubPackages = async ({ offset, limit, query }) => {
  try {
    const resp = await ApiClient.get("/sub-packages/all", {
      params: { page: offset, page_size: limit, query: query },
    });
    const result = handleApiResponse(resp);
    return result;
  } catch (err) {
    console.log(err);
    handleApiError(err);
  }
};
export const createSubPackage = async (values) => {
  try {
    const resp = await ApiClient.post("/sub-packages/sub-package", values);
    const result = handleApiResponse(resp);
    return result;
  } catch (err) {
    console.log(err);
    handleApiError(err);
  }
};
export const updateSubPackage = async (values) => {
  try {
    const resp = await ApiClient.put("/sub-packages/sub-package", values);
    const result = handleApiResponse(resp);
    return result;
  } catch (err) {
    console.log(err);
    handleApiError(err);
  }
};
export const getSubPackageById = async ({ id }) => {
  try {
    const resp = await ApiClient.get("/sub-packages/sub-package", {
      params: { id: id },
    });
    const result = handleApiResponse(resp);
    return result;
  } catch (err) {
    console.log(err);
    handleApiError(err);
  }
};
